import styled from 'styled-components';

import { colors, device, fonts } from 'shared/defaultTheme';

export const FormWrapper = styled.form`
  display: block;
  margin-bottom: 30px;
  .form-container {
    height: auto;
  }
  .group-input-container {
    padding-top: 19px;
  }
  .e-multiselect.e-checkbox .e-multi-select-wrapper .e-searcher {
    display: none;
  }
  @media ${device.sm} {
    .mobile-input-container {
      margin-bottom: 19px;
    }
    .form-container {
      height: auto;
    }
  }
  .home__btn {
    height: 40px;
    width: 110px;
  }
  .required-mark {
    color: ${colors.error};
  }
`;

export const GroupInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  .information-icon {
    position: relative;
    top: -2px;
    cursor: pointer;
  }
  .label-input-notify {
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
  }
`;
